import { Badge } from "@/components/ui/badge";

import {
  jobHealthToBackgroundColor,
  jobHealthToDotColor,
  jobHealthToHoverBackgroundColor,
  jobHealthToLabel,
} from "@/lib/constants";
import { cn } from "@/lib/utils";
import { JobHealth } from "@/types";

export const JobHealthBadge = ({ health }: { health: JobHealth }) => {
  return (
    <Badge
      variant="secondary"
      className={cn(
        "gap-2 text-sm font-normal",
        jobHealthToBackgroundColor[health],
        jobHealthToHoverBackgroundColor[health],
      )}
    >
      <span
        className={cn("h-2 w-2 rounded-full", jobHealthToDotColor[health])}
      />
      {jobHealthToLabel[health]}
    </Badge>
  );
};
